export default (event: string, props?: object) => {
	// @ts-ignore
	umami.track(event, props);
};
